import type { ResellerPartnerConfig } from '../reseller-partners';

import { apptics } from './apptics';
import type { BrandConfig } from './types';

/**
 * White-label (full infra fork) brands, compiled in ONLY on their own deploy.
 *
 * The condition reads `import.meta.env.VITE_BRAND` inline so Vite replaces it
 * at build time and Rollup drops the branch: the shared deploy (no
 * `VITE_BRAND`), served on every partner host, ships no white-label name.
 * Partner-mode brands never live here: the middleware injects the current
 * partner's brand (`../partner-injection.ts`).
 */
// The Apptics Vercel project sets VITE_APP_NAME=Apptics and no VITE_BRAND. Exact
// literals only, so the shared build still folds this to false.
const isAppticsDeploy =
  import.meta.env.VITE_BRAND === 'apptics' ||
  import.meta.env.VITE_BRAND === 'fmj' ||
  import.meta.env.VITE_APP_NAME === 'Apptics';

export const whitelabelBrands: Readonly<Record<string, BrandConfig>> = isAppticsDeploy
  ? { apptics, fmj: apptics }
  : {};

/** The Apptics deploy's own reseller entry (org tag `fmj`), same deploy rule. */
export const whitelabelResellers: Readonly<Record<string, ResellerPartnerConfig>> = isAppticsDeploy
  ? { fmj: { brandName: apptics.appName, logo: apptics.logo, logoDark: apptics.logoDark } }
  : {};
